'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = undefined;

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _core = require('lodash/core');

var _core2 = _interopRequireDefault(_core);

var _sdk = require('wave-charts/sdk');

var _sdk2 = _interopRequireDefault(_sdk);

var _index = require('../sfdc-abstract-legend/index.js');

var _index2 = _interopRequireDefault(_index);

var _metadata = require('./metadata.json');

var _metadata2 = _interopRequireDefault(_metadata);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var formatNumber = _sdk2.default.formatNumber;
var ref = _sdk2.default.utils;
var constants = ref.constants;
var plotUtils = ref.plotUtils;
var ref$1 = _sdk2.default.shapes;
var NumberText = ref$1.NumberText;
var Layer = ref$1.Layer;
var Rect = ref$1.Rect;
var MAX_LABEL_WIDTH = 120;
var MAX_GRADIENT_LENGTH = 200;
var legendPadding = constants.LEGEND.PADDING;

function _getMinMaxWidth(domain, format) {
  var formatter = formatNumber(format, true);
  return [plotUtils.getTextWidth(formatter(domain[0])) + legendPadding, plotUtils.getTextWidth(formatter(domain[1])) + legendPadding];
}

var GradientLegend = function (AbstractLegend) {
  function GradientLegend() {
    AbstractLegend.apply(this, arguments);
  }

  if (AbstractLegend) GradientLegend.__proto__ = AbstractLegend;
  GradientLegend.prototype = (0, _create2.default)(AbstractLegend && AbstractLegend.prototype);
  GradientLegend.prototype.constructor = GradientLegend;

  GradientLegend.prototype.sanitizeConfig = function sanitizeConfig() {
    AbstractLegend.prototype.sanitizeConfig.call(this);
    this.config.selectMode = constants.SELECTMODE.NONE;
  };

  GradientLegend.prototype.getDefaultConfig = function getDefaultConfig() {
    return _core2.default.extend(AbstractLegend.prototype.getDefaultConfig.call(this), {
      domain: [0, 0],
      range: this.config.theme.getGradientLegendColor(),
      headerAlign: "center",
      maxLength: MAX_GRADIENT_LENGTH,
      width: constants.GRADIENT_LEGEND.GRADIENT.WIDTH
    });
  };

  GradientLegend.prototype.getVerticalSize = function getVerticalSize() {
    var config = this.config;

    if (!config) {
      return [0, 0];
    }

    var domain = config.domain;
    var format = config.format;
    var maxLength = config.maxLength;
    var headerSize = this.getHeaderSize(true);
    var height = headerSize[1] + (maxLength || MAX_GRADIENT_LENGTH) + (constants.LEGEND.TEXT.SIZE + legendPadding * 2) * 2;

    var minMax = _getMinMaxWidth(domain, format);

    var width = [headerSize[0], minMax[0], minMax[1], config.width || constants.GRADIENT_LEGEND.GRADIENT.WIDTH];
    return [Math.max.apply(Math, width), height];
  };

  GradientLegend.prototype.getHorizontalSize = function getHorizontalSize() {
    var config = this.config;

    if (!config) {
      return [0, 0];
    }

    var domain = config.domain;
    var format = config.format;
    var maxLength = config.maxLength;
    var headerSize = this.getHeaderSize(false);
    var height = constants.LEGEND.TEXT.SIZE + legendPadding;

    var minMax = _getMinMaxWidth(domain, format);

    var width = headerSize[0] + (maxLength || MAX_GRADIENT_LENGTH) + minMax[0] + minMax[1];
    return [width, height];
  };

  GradientLegend.prototype.plotFunction = function plotFunction(plot, rows, initWidth, initHeight) {
    var config = this.config;
    var transforms = config.transforms;
    var theme = config.theme;
    var domain = config.domain;
    var range = config.range;
    var format = config.format;
    var maxLength = config.maxLength;
    var sorting = config.sorting;
    var horizontalLayout = !!transforms.rotate;
    var formatter = formatNumber(format, true);
    var plotLayer = new Layer({
      cell: plot,
      key: "plot",
      canHover: false,
      canSelect: false
    });
    var scene = plot.getScene();
    var padding = constants.LEGEND.PADDING;
    var maxGradientLength = maxLength || Number.POSITIVE_INFINITY;
    var maxVal = domain[1];
    var minVal = domain[0];

    if (minVal === +Infinity || maxVal === -Infinity) {
      return;
    } // NOTE: we don't look at legend sorting "type" at all for Gradient legend.  So setting "type" has no effect for gradient charts
    // For vertical gradient, the max is on top, or we swap the min/max if order is descending.


    if (!sorting && !horizontalLayout || sorting && sorting.order === constants.SORT.ORDER.DESC) {
      var tmp = minVal;
      minVal = maxVal;
      maxVal = tmp;
    } // For horizontal gradient, the default is ascending, and for vertical, the default is descending.
    // So, if we need to swap the min/max, we need to reverse the color gradient too.


    if (minVal != maxVal && (horizontalLayout && sorting && sorting.order === constants.SORT.ORDER.DESC || !horizontalLayout && sorting && sorting.order === constants.SORT.ORDER.ASC)) {
      range = range.reverse();
    }

    var whiteSpaceSize = 2 * MAX_LABEL_WIDTH;
    var minValTextWidth = plotUtils.getTextWidth(formatter(minVal));
    var maxValTextWidth = plotUtils.getTextWidth(formatter(maxVal));
    var minValWidth = Math.min(minValTextWidth, whiteSpaceSize / 2);
    var maxValWidth = Math.min(maxValTextWidth, whiteSpaceSize - minValWidth);
    var textSize = horizontalLayout ? minValWidth + maxValWidth + 10 : 40;
    var height = initHeight - padding / 2;
    var width = initWidth; // gradient

    var gradientWidth = config.width;
    gradientWidth = Math.max(Math.min(gradientWidth, width - padding), constants.GRADIENT_LEGEND.GRADIENT.MIN_WIDTH);
    var gradientHeight = Math.min(height - padding - textSize, maxGradientLength);
    gradientHeight = Math.max(gradientHeight, gradientWidth * constants.GRADIENT_LEGEND.GRADIENT.MIN_RATIO);
    var horizontalOffset = width / 2 - gradientWidth / 2;
    var verticalCenterX = config.isCombo ? -(config.showHeader ? initWidth : Math.max(minValWidth, maxValWidth)) / 2 + Math.max(minValTextWidth, maxValTextWidth, gradientWidth) / 2 + padding : 0; // min val

    new NumberText({
      key: "minval",
      layer: plotLayer,
      x: horizontalLayout ? horizontalOffset + Math.max(gradientWidth, constants.LEGEND.TEXT.SIZE) / 2 : verticalCenterX,
      y: horizontalLayout ? 5 : padding,
      valign: "middle",
      halign: horizontalLayout ? "right" : "center",
      vertical: horizontalLayout,
      stroke: theme.getGradientLegendTextColor(),
      format: format,
      compact: true,
      number: minVal,
      padding: horizontalLayout ? {
        "bottom": padding / 2
      } : {
        "right": padding / 2,
        "left": padding / 2
      },
      maxWidth: horizontalLayout ? whiteSpaceSize / 2 : MAX_LABEL_WIDTH
    });
    new Rect({
      key: "gradient",
      layer: plotLayer,
      x: horizontalLayout ? horizontalOffset : verticalCenterX - gradientWidth / 2,
      w: gradientWidth,
      h: horizontalLayout ? gradientHeight : -gradientHeight,
      vertical: true,
      cornerRadius: gradientWidth / 2,
      fill: minVal === maxVal ? range.toRepresentativeColor() : range
    }); // max val

    new NumberText({
      key: "maxval",
      layer: plotLayer,
      x: horizontalLayout ? horizontalOffset + Math.max(gradientWidth, constants.LEGEND.TEXT.SIZE) / 2 : verticalCenterX,
      valign: "middle",
      halign: horizontalLayout ? "left" : "center",
      vertical: horizontalLayout,
      stroke: theme.getGradientLegendTextColor(),
      format: format,
      compact: true,
      number: maxVal,
      padding: horizontalLayout ? {
        "right": padding,
        "bottom": padding / 2
      } : {
        "bottom": padding,
        "right": padding / 2,
        "left": padding / 2
      },
      maxWidth: horizontalLayout ? whiteSpaceSize - minValWidth : MAX_LABEL_WIDTH
    });
    plotLayer.applyLayout({
      type: "vbox",
      spacer: constants.GRADIENT_LEGEND.TEXT.PADDING
    });
    var plotBb = plotLayer.boundingBox();
    var totalWidth;

    if (!horizontalLayout && plotBb) {
      totalWidth = Math.max(plotBb.w + padding, config.showHeader ? initWidth : Math.max(minValWidth, maxValWidth));
      plotLayer.set({
        x: totalWidth / 2 - padding / 2
      });
    }

    scene.adjustRowToFit(plot.get("row"));
    scene.adjustColumnToFit(plot.get("column"));
  };

  return GradientLegend;
}(_index2.default);

exports.default = GradientLegend;

var getMetadata = function getMetadata() {
  return _metadata2.default;
};

exports.getMetadata = getMetadata;